module.exports = {"TXTWCL_Popular_Accumulators":{"id":"TXTWCL_Popular_Accumulators","defaultMessage":"Multiple popolari","ontario":"Multiple popolari"}}